// extracted by mini-css-extract-plugin
var _1 = "O8M_EKAcLuBNGEChNMpo";
var _2 = "GssMoka0yitDj2L0N2qO";
var _3 = "PM0VxwNMus0gqpqsQgZY";
export { _1 as "Spinner", _2 as "SpinnerWrap", _3 as "spin" }
